import { invoke } from "../invoke";
import { scenelikeDisplayName } from "./unplaced";
import {
  normalizePayload,
  type EditorPayload,
  type RawEditorPayload,
} from "./core";

import type { NoteEntry } from "../outlineEntityTypes";

export type { NoteEntry };

export function noteEntryDisplayName(entry: NoteEntry): string {
  return entry.title.length > 0
    ? entry.title
    : scenelikeDisplayName(entry.name, entry.parked);
}

export async function listProjectNotes(rootPath: string): Promise<NoteEntry[]> {
  return invoke<NoteEntry[]>("list_project_notes", { rootPath });
}

export async function createProjectNote(
  rootPath: string,
  name: string,
): Promise<EditorPayload> {
  const raw = await invoke<RawEditorPayload>("create_project_note", {
    rootPath,
    name,
  });
  return normalizePayload(raw);
}

export async function openProjectNote(
  rootPath: string,
  name: string,
): Promise<EditorPayload> {
  const raw = await invoke<RawEditorPayload>("open_project_note", {
    rootPath,
    name,
  });
  return normalizePayload(raw);
}

export async function renameProjectNote(
  rootPath: string,
  fromName: string,
  toName: string,
): Promise<EditorPayload> {
  const raw = await invoke<RawEditorPayload>("rename_project_note", {
    rootPath,
    fromName,
    toName,
  });
  return normalizePayload(raw);
}

export async function deleteProjectNote(
  rootPath: string,
  name: string,
): Promise<EditorPayload> {
  const raw = await invoke<RawEditorPayload>("delete_project_note", {
    rootPath,
    name,
  });
  return normalizePayload(raw);
}
